exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (max-width:599px){carousel .carousel{height:272px}}@media (min-width:600px){carousel .carousel{height:460px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/vehicle/catalog/components/carousel/carousel.styl
// module id = 1068
// module chunks = 0